import * as Sentry from '@sentry/react'
import { EventProps, UserProfile, ITrackingProvider, TrackingInitOptions } from '../../../interfaces/event-tracker'

export class SentryProvider implements ITrackingProvider {
  init (_options?: TrackingInitOptions): void {
    // Sentry is already initialized in initializeSentry.ts during preInit
  }

  trackEvent ({ key, metadata }: EventProps): void {
    try {
      Sentry.addBreadcrumb({
        category: 'event-tracker',
        message: key,
        data: metadata,
        level: 'info'
      })
    } catch {}
  }

  setUser (user: UserProfile): void {
    try {
      Sentry.setUser({
        id: user.uid,
        email: user.email,
        username: `${user.nombre} ${user.apellido}`
      })
      Sentry.setTag('workspace_id', user.escritorio_seleccionado)
      Sentry.setTag('plan', user.tipo_usuario)
    } catch {}
  }
}
